import _objectWithoutProperties from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["category", "level", "message"];
import _regeneratorRuntime from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { addBreadcrumb } from '@sentry/core';
import { logger } from '@sentry/utils';
import { REPLAY_EVENT_NAME, UNABLE_TO_SEND_REPLAY } from '../constants.js';
import { isRrwebError } from '../util/isRrwebError.js';
/**
 * Returns a listener to be added to `addGlobalEventProcessor(listener)`.
 */

function handleGlobalEventListener(replay) {
  return function (event) {
    // Do not apply replayId to the root event
    if ( // @ts-ignore new event type
    event.type === REPLAY_EVENT_NAME) {
      // Replays have separate set of breadcrumbs, do not include breadcrumbs
      // from core SDK
      delete event.breadcrumbs;
      return event;
    } // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
    // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users


    if (isRrwebError(event) && !_optionalChain([replay, 'access', function (_) {
      return _.getOptions;
    }, 'call', function (_2) {
      return _2();
    }, 'access', function (_3) {
      return _3._experiments;
    }, 'optionalAccess', function (_4) {
      return _4.captureExceptions;
    }])) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Replay] Ignoring error from rrweb internals', event);
      return null;
    } // Only tag transactions with replayId if not waiting for an error
    // @ts-ignore private


    if (event.type !== 'transaction' || replay.recordingMode === 'session') {
      event.tags = _objectSpread(_objectSpread({}, event.tags), {}, {
        replayId: _optionalChain([replay, 'access', function (_5) {
          return _5.session;
        }, 'optionalAccess', function (_6) {
          return _6.id;
        }])
      });
    } // Collect traceIds in _context regardless of `recordingMode` - if it's true,
    // _context gets cleared on every checkout


    if (event.type === 'transaction' && event.contexts && event.contexts.trace && event.contexts.trace.trace_id) {
      replay.getContext().traceIds.add(event.contexts.trace.trace_id);
      return event;
    } // no event type means error


    if (!event.type) {
      replay.getContext().errorIds.add(event.event_id);
    }

    var exc = _optionalChain([event, 'access', function (_7) {
      return _7.exception;
    }, 'optionalAccess', function (_8) {
      return _8.values;
    }, 'optionalAccess', function (_9) {
      return _9[0];
    }]);

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _optionalChain([replay, 'access', function (_10) {
      return _10.getOptions;
    }, 'call', function (_11) {
      return _11();
    }, 'access', function (_12) {
      return _12._experiments;
    }, 'optionalAccess', function (_13) {
      return _13.traceInternals;
    }])) {
      addInternalBreadcrumb({
        message: "Tagging event (".concat(event.event_id, ") - ").concat(event.message, " - ").concat(_optionalChain([exc, 'optionalAccess', function (_14) {
          return _14.type;
        }]) || 'Unknown', ": ").concat(_optionalChain([exc, 'optionalAccess', function (_15) {
          return _15.value;
        }]) || 'n/a')
      });
    } // Need to be very careful that this does not cause an infinite loop


    if (replay.recordingMode === 'error' && event.exception && event.message !== UNABLE_TO_SEND_REPLAY // ignore this error because otherwise we could loop indefinitely with trying to capture replay and failing
    ) {
      setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return replay.flushImmediate();

              case 2:
                if (replay.stopRecording()) {
                  // Reset all "capture on error" configuration before
                  // starting a new recording
                  replay.recordingMode = 'session';
                  replay.startRecording();
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }

    return event;
  };
}

function addInternalBreadcrumb(arg) {
  var category = arg.category,
      level = arg.level,
      message = arg.message,
      rest = _objectWithoutProperties(arg, _excluded);

  addBreadcrumb(_objectSpread({
    category: category || 'console',
    level: level || 'debug',
    message: "[debug]: ".concat(message)
  }, rest));
}

export { handleGlobalEventListener };